import { render, staticRenderFns } from "./NoMore.vue?vue&type=template&id=536f787c&scoped=true"
import script from "./NoMore.vue?vue&type=script&lang=js"
export * from "./NoMore.vue?vue&type=script&lang=js"
import style0 from "./NoMore.vue?vue&type=style&index=0&id=536f787c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536f787c",
  null
  
)

export default component.exports